import EventModel from '~/models/event.js'

export default class extends EventModel {
	static _routeKey = 'appointment'

	tail = {
		duration: () => ['duration', this.duration != null ? this.durationHuman() : null],
		starts_at: () => ['start date', this.starts_at != null ? this.startHM() : null],
		ends_at: () => ['end date', this.ends_at != null ? this.endHM() : null],
		completed_at: () => ['completed at', this.vue.$help.formatDateTime(this.completed_at, { date: true, time: true }), ''],
		belongs_id: () => ['Associated deal', parseInt(this.belongs_type) != 102 ? this.belongs_id : 'No deal associated'],
		createdDescription: () => '"' + this.title + '" was created',
		virtual_ends_at: () => [null, null],
		// extra_keys: {
		//     belongs_id: () => (this.belongs_id ? ['Associated deal', this.belongs_id] : null),
		// },
	}

	_logIcon() {
		return 'IconAppointmentDraftCircle'
	}

	me() {
		return 'Appointment'
	}

	timeline(user) {
		let t = this._timeline(user)
		let l = this.level('deal')
		console.log('l', this)

		return {
			title: this.published_at == null ? t.user + ' created a draft' : t.user + ' created a new event',
			description: this.title,
			created_at: this.created_at,
			icon: this.published_at == null ? 'IconAppointmentDraftCircle' : 'IconAppointmentCircle',
			breakdown: {
				title: this.title,
				description: this.description,
				status: {
					type: 'statusMenu',
					text: this.status,
					circleClass: this.statusClass(),
					event: this,
					// icon: this.statusIconName(),
				},
				'start date': this.startHM(),
				Duration: this.durationHuman(),
				'Associated deal':
					l == false
						? null
						: {
								type: 'NuxtLink',
								to: l.link,
								text: l.title,
							},
			},
			options: {
				View: () => this.view(1),
				Edit: () => this.edit(),
				'Mark as complete': this.canComplete() ? () => this.complete() : null,
				Delete: () => this.destroy(),
			},
		}
	}
}
